import DataGrid from 'react-data-grid';
import { parseBatchLots } from '../utilities/Validate'

const DataTable = ({ columns, rows, onSort, sortColumn, sortDirection }) => {
  return <DataGrid
    columns={columns}
    rows={rows}
    style={{ height: '75vh' }}
    sortColumn={sortColumn}
    sortDirection={sortDirection}
    onSort={onSort}
    rowHeight={row => {
      const lots = row.row.actualBatchNumbers ? parseBatchLots(row.row.actualBatchNumbers) : parseBatchLots(row.row.batchNumbers)
      if (lots.length < 2) return 65
      return lots.length * 30
    }}
    defaultColumnOptions={{
      resizable: true
    }}
  />
}
export default DataTable